/**
 * Amenity category and list constants
 */

// Primary categories
export const PRIMARY_CATEGORIES = [
  { value: 'front_office', label: 'Front office' },
  { value: 'services', label: 'Services' },
  { value: 'facility', label: 'Facility' },
  { value: 'f_b', label: 'F&B' },
  { value: 'recreation', label: 'Recreation' },
  { value: 'package_includes', label: 'Package Includes' },
  { value: 'activities', label: 'Activities' },
];

// Comprehensive amenity lists for each category
export const AMENITIES_BY_CATEGORY = {
  front_office: [
    '24-hour Front Desk',
    'Front Desk',
    'Managers Reception',
    'Video Checkout',
    'Late Check-out Available',
    'Late Check-in',
    'Early Check-in',
    'Private Check-in',
    'Travel Desk',
    'Contactless Checkin',
    'Hourly Check-in',
    'Airline Desk',
    'Check-in Kiosk',
    'Concierge Desk',
    'Express Check-in',
    'Express Check-out',
    'Free Airport Shuttle',
    'Contactless Checkout',
    'Luggage Storage',
    'Bell Service',
    'Valet Service',
    'Currency Exchange',
    'Tour Desk',
    'Ticket Service',
    'Business Center Access',
    'Wake-up Service',
    'Message Service',
  ],
  services: [
    '24-hour Front Desk',
    'Daily Housekeeping',
    'Room Service',
    '24-hour Room Service',
    'Laundry Service',
    'Dry Cleaning Service',
    'Concierge Service',
    'Wake-up Call Service',
    'Turndown Service',
    'Luggage Storage',
    'Valet Parking',
    'Airport Shuttle',
    'Shuttle Service',
    'Car Rental Service',
    'Multilingual Staff',
    'Business Center Access',
    'Photocopying Service',
    'Fax Service',
    'Printing Service',
  ],
  comfort: [
    'Air Conditioning',
    'Heating',
    'Individual Climate Control',
    'Blackout Curtains',
    'Soundproofing',
    'In-room Safe',
    'Iron and Ironing Board',
    'Luggage Rack',
    'Hair Dryer',
    'Bathrobes',
    'Slippers',
    'Comfortable Seating Area',
    'Work Desk',
    'Ergonomic Chair',
    'Closet with Hangers',
    'Full-Length Mirror',
    'Premium Bedding',
    'Pillow Menu',
    'Extra Pillows',
    'Extra Blankets',
    'Alarm Clock',
    'Complimentary Toiletries',
    'Daily Housekeeping',
    'Turndown Service',
  ],
  dining: [
    'Mini Bar',
    'Mini Refrigerator',
    'Refrigerator',
    'Microwave',
    'Coffee Maker',
    'Tea Maker',
    'Electric Kettle',
    'Kitchenette',
    'Dining Table',
    'Dining Chairs',
    'Dishware',
    'Utensils',
    'Wine Glasses',
    'Bottle Opener',
    'Ice Bucket',
    'Complimentary Bottled Water',
    'Tea and Coffee Supplies',
    'Room Service',
    'In-room Dining',
    'On-site Restaurant',
    'Complimentary Breakfast',
  ],
  technology: [
    'Free WiFi',
    'High-Speed Internet',
    'WiFi in Rooms',
    'WiFi in Public Areas',
    'Flat-Screen TV',
    'Smart TV',
    'Cable TV',
    'Satellite TV',
    'Premium Channels',
    'Streaming Services',
    'Netflix',
    'USB Charging Ports',
    'Multiple Power Outlets',
    'Universal Power Adapters',
    'Bluetooth Speaker',
    'Digital Alarm Clock',
    'Telephone',
    'In-room Tablet',
    'Smart Room Controls',
    'Voice-Controlled Features',
    'Digital Room Key',
    'Online Check-in',
    'Online Check-out',
  ],
  facility: [
    'Free Parking',
    'Valet Parking',
    'Parking Garage',
    'Electric Vehicle Charging Station',
    'Bicycle Parking',
    'Free WiFi',
    'High-Speed Internet',
    'WiFi in Public Areas',
    'WiFi in Rooms',
    'Business Center',
    'Meeting Rooms',
    'Conference Facilities',
    'Banquet Hall',
    'Elevator',
    'Air Conditioning',
    'Heating',
    'Smoking Area',
    'Non-Smoking Property',
    'ATM on Site',
    'Gift Shop',
    'Beauty Salon',
    'Barber Shop',
    'Library',
    'Chapel',
    'Prayer Room',
    'Vending Machine',
    'Ice Machine',
    'Luggage Storage',
    'Safe Deposit Box',
    'Security Service',
    'CCTV',
    'Fire Safety',
    'First Aid Kit',
    'Wheelchair Accessible',
    'Accessible Parking',
    'Accessible Elevator',
    'Accessible Toilet',
  ],
  f_b: [
    'Restaurant',
    'On-site Restaurant',
    'Fine Dining Restaurant',
    'Casual Dining',
    'Buffet Restaurant',
    'Bar',
    'Lounge',
    'Pool Bar',
    'Rooftop Bar',
    'Sports Bar',
    'Cocktail Bar',
    'Wine Bar',
    'Coffee Shop',
    'Café',
    'Breakfast Buffet',
    'Continental Breakfast',
    'Full English Breakfast',
    'American Breakfast',
    'Vegetarian Breakfast',
    'Vegan Options',
    'Halal Food',
    'Kosher Food',
    'Gluten-free Options',
    'Room Service',
    '24-hour Room Service',
    'In-room Dining',
    'Snack Bar',
    'Minibar',
    'Complimentary Water',
    'Tea/Coffee Making Facilities',
    'Special Diet Menus',
    'Kids Menu',
    'Outdoor Dining',
    'Private Dining',
    'Catering Service',
    'BBQ Facilities',
  ],
  recreation: [
    'Swimming Pool',
    'Indoor Pool',
    'Outdoor Pool',
    'Infinity Pool',
    'Heated Pool',
    'Pool with View',
    'Pool Bar',
    'Poolside Service',
    'Fitness Center',
    'Gym',
    'Wellness Center',
    'Spa',
    'Massage Service',
    'Sauna',
    'Steam Room',
    'Hot Tub',
    'Jacuzzi',
    'Yoga Classes',
    'Pilates Classes',
    'Fitness Classes',
    'Personal Trainer',
    'Tennis Court',
    'Squash Court',
    'Basketball Court',
    'Volleyball Court',
    'Badminton Court',
    'Table Tennis',
    'Billiards',
    'Darts',
    'Golf Course',
    'Golf Driving Range',
    'Mini Golf',
    'Beach Access',
    'Beach Chairs',
    'Beach Umbrellas',
    'Water Sports',
    'Diving',
    'Snorkeling',
    'Kayaking',
    'Canoeing',
    'Fishing',
    'Boat Rental',
    'Bicycle Rental',
    'Hiking Trails',
    'Jogging Track',
    'Garden',
    'Terrace',
    'Sun Deck',
    'Game Room',
    'Entertainment Room',
    'Karaoke',
    'Live Music',
    'Nightclub',
    'Casino',
  ],
  package_includes: [
    'Breakfast Included',
    'All Meals Included',
    'Half Board',
    'Full Board',
    'All Inclusive',
    'Welcome Drink',
    'Complimentary WiFi',
    'Airport Transfer',
    'Room Upgrade',
    'Late Check-out',
    'Early Check-in',
    'Spa Access',
    'Fitness Center Access',
    'Pool Access',
    'Beach Access',
    'Parking Included',
    'Minibar Included',
    'Room Service Included',
    'Laundry Service Included',
    'Tour Included',
    'Activity Included',
    'Dining Credit',
    'Spa Credit',
    'Shopping Credit',
    'Entertainment Included',
    'Kids Club Access',
    'Babysitting Included',
    'Pet Fee Included',
    'Resort Fee Included',
    'Service Charge Included',
    'Tax Included',
  ],
  activities: [
    'City Tours',
    'Cultural Tours',
    'Historical Tours',
    'Food Tours',
    'Wine Tasting',
    'Cooking Classes',
    'Art Classes',
    'Photography Tours',
    'Wildlife Tours',
    'Safari Tours',
    'Adventure Tours',
    'Hiking Tours',
    'Biking Tours',
    'Water Sports Activities',
    'Diving Tours',
    'Snorkeling Tours',
    'Fishing Tours',
    'Boat Tours',
    'Sunset Cruises',
    'Island Hopping',
    'Beach Activities',
    'Beach Volleyball',
    'Beach Soccer',
    'Yoga Sessions',
    'Meditation Sessions',
    'Wellness Activities',
    'Spa Activities',
    'Fitness Activities',
    'Tennis Lessons',
    'Golf Lessons',
    'Swimming Lessons',
    'Dance Classes',
    'Music Events',
    'Live Performances',
    'Entertainment Shows',
    'Movie Nights',
    'Game Nights',
    'Trivia Nights',
    'Karaoke Nights',
    'Theme Nights',
    'Kids Activities',
    'Children\'s Entertainment',
    'Playground Activities',
    'Educational Activities',
    'Workshops',
    'Seminars',
    'Conferences',
    'Team Building Activities',
    'Corporate Activities',
    'Group Activities',
  ],
};

/**
 * Transform amenity name to code
 */
export const amenityNameToCode = (name) => {
  return name.toLowerCase().replace(/\s+/g, '_');
};

/**
 * Create temporary ID for amenity
 */
export const createTempAmenityId = (category, index) => {
  return `amenity_${category}_${index}`;
};

/**
 * Check if ID is a temporary ID
 */
export const isTempId = (id) => {
  return typeof id === 'string' && id.startsWith('amenity_');
};

